import * as Yup from "yup";

const tokenValidation = Yup.string().required("Token is required.");

const validateLatitude = Yup.string()
  .nullable()
  .test("is-valid-latitude", "Latitude must be between -90 and 90", (value) => {
    if (value === "" || value === null || value === undefined) return true; // Allow empty or null values
    const lat = parseFloat(value);
    return !isNaN(lat) && lat >= -90 && lat <= 90;
  })
  .required();

const validateLongitude = Yup.string()
  .nullable() // allows null or empty values
  .test("is-valid-longitude", "Longitude must be between -180 and 180", (value) => {
    if (value === "" || value === null || value === undefined) return true; // Allow empty or null values
    const lon = parseFloat(value);
    return !isNaN(lon) && lon >= -180 && lon <= 180;
  })
  .required();

const validatePhoneNumber = Yup.string()
  .length(10, "Phone number must be exactly 10 digits.")
  .matches(/^[6-9]{1}[0-9]{9}$/, "Phone number must start with 6-9 and be followed by 9 digits.")
  .required("Phone number is required.");

const validateConnectors = Yup.array().of(
  Yup.object().shape({
    connectorId: Yup.number().positive("Connector Id must be a positive number"),
    connectorType: Yup.string(),
  })
);
export const validateChargerId = Yup.string()
  .matches(/^[0-9a-fA-F]{12}$/, "Charger ID must be a 12-digit hexadecimal string.")
  .required("Charger ID is required.");

const alphaNumericName = Yup.string()
  .matches(/^[a-zA-Z0-9]+$/, "Name must be alphanumeric.")
  .required("Name is required.");

export const validateEmail = Yup.string().email("Please enter valid email").required("Please enter valid Email");

// common validation function to validate mandatory string
const validateStrRequired = (name) => {
  return Yup.string().required(`${name} is required.`);
};

// ******************************************Login validation************************************************
export const loginValidate = Yup.object().shape({
  email: validateEmail,
  password: Yup.string().required("password is required."),
});

export const chargerIdValidation = Yup.object().shape({
  chargerId: validateStrRequired("Charger Id"),
});

export const locationValidation = Yup.object().shape({
  locationId: validateStrRequired("Location Id"),
});
// general validation for all the token and Id objects
export const tokenAndIdValidation = Yup.object().shape({
  token: tokenValidation,
  id: validateStrRequired("Id"),
});

//to validate the id, token and type
export const typeAndIdValidation = Yup.object().shape({
  token: tokenValidation,
  id: validateStrRequired("Id"),
  type: validateStrRequired("Type"),
});
//  name, phoneNumber, email, type, role, gst
// to validate host register tab1
export const hostRegisterValidationTab1 = Yup.object().shape({
  name: validateStrRequired("Name"),
  phoneNumber: Yup.string()
    .length(10, "Phone number must be exactly 10 digits.")
    .matches(/^[6-9]{1}[0-9]{9}$/, "Phone number must start with 6-9 and be followed by 9 digits."),
  email: validateEmail,
  type: validateStrRequired("Type"),
  gst: Yup.string(),
});

// to validate host registration
export const hostRegistrationValidation = Yup.object().shape({
  name: validateStrRequired("Name"),
  phoneNumber: Yup.string()
    .length(10, "Phone number must be exactly 10 digits.")
    .matches(/^[6-9]{1}[0-9]{9}$/, "Phone number must start with 6-9 and be followed by 9 digits."),
  email: validateEmail,
  type: validateStrRequired("Type"),
  role: validateStrRequired("Role"),
  gst: Yup.string(),
  parentId: validateStrRequired(),
  address: Yup.string(),
});
// ***************************************LOCATION API'S VALIDATION*****************************************************
//1.create Location validation
export const createLocationValidation = Yup.object().shape({
  token: tokenValidation,
  latitude: validateLatitude,
  longitude: validateLongitude,
  ownerId: Yup.string().required(),
  imageId: Yup.string(),
  visibility: Yup.boolean(),
  address: validateStrRequired("Address"),
  name: validateStrRequired("Name"),
});

// vaidate the create Location tab 1
export const addLocationTabValidation = Yup.object().shape({
  name: validateStrRequired("Name"),
  latitude: validateLatitude,
  longitude: validateLongitude,
  address: Yup.string(),
  visibility: Yup.boolean(),
});

// validate add Location
export const addLocationValidation = Yup.object().shape({
  name: validateStrRequired("Name"),
  latitude: validateLatitude,
  longitude: validateLongitude,
  address: Yup.string(),
  visibility: Yup.boolean(),
  hostId: validateStrRequired("Host Id"),
  imageId: Yup.string(),
});

//2.validation to get the location by owner Id
export const getLocationByOwnerIdValidation = Yup.object().shape({
  token: tokenValidation,
  ownerId: validateStrRequired("Owner Id"),
});

//*************************************************CHARGER API'S VALIDATION*********************************************
// 1.create charger validation
export const createChargerValidation = Yup.object().shape({
  token: tokenValidation,
  chargerId: validateChargerId,
  serialNumber: validateStrRequired("Serial Number"),
  vendorId: validateStrRequired("Vendor Id"),
  modelType: Yup.string(),
  protocolType: validateStrRequired("Protocol Type"),
  connectors: validateConnectors,
  currency: validateStrRequired("Currency"),
  perUnitRate: validateStrRequired("perUnitRate"),
  deploymentStatus: Yup.string(),
  ocppConnections: Yup.object()
    .shape({
      ocppId: Yup.string().required("OCPP Id is required"),
    })
    .required(),
  locationId: Yup.string(),
  image: Yup.string(),
  ownerId: Yup.string(),
  rating: Yup.string(),
});

// vaidate the create charger tab 1
export const createChargerTab1Validation = Yup.object().shape({
  chargerId: validateChargerId,
  name: alphaNumericName,
  serialNumber: validateStrRequired("Serial Number"),
  locationId: validateStrRequired("Location"),
  // modelType: Yup.string(),
  connectors: validateConnectors,
});
// vaidate the create charger tab 3
export const createChargerTab3Validation = Yup.object().shape({
  perUnitRate: validateStrRequired("perUnitRate"),
  deploymentStatus: validateStrRequired("Deployment Status"),
  ocppId: Yup.string()
    .matches(/^[a-zA-Z0-9]+$/, "OCPP ID must be alphanumeric string")
    .required("OCPP Id is required"),
});
export const addChargerValidation = Yup.object().shape({
  chargerId: validateChargerId,
  serialNumber: validateStrRequired("Serial Number"),
  name: alphaNumericName,
  vendorId: validateStrRequired("Vendor Id"),
  modelType: Yup.string(),
  protocolType: validateStrRequired("Protocol Type"),
  connectors: validateConnectors,
  deploymentStatus: validateStrRequired("Deployment Status"),
  ocppId: Yup.string()
    .matches(/^[a-zA-Z0-9]+$/, "OCPP ID must be alphanumeric string")
    .required("OCPP Id is required"),
  currency: validateStrRequired("Currency"),
  perUnitRate: Yup.number().required("Number is required").moreThan(0, "Unit price cannot be 0"),
  rating: Yup.string(),
  locationId: validateStrRequired("Location"),
  imageId: Yup.string(),
  hostId: validateStrRequired("Host Id"),
});

// 2.validation to delete the charger by Id
export const deleteChargerByIdValidation = Yup.object().shape({
  token: tokenValidation,
  chargerId: validateStrRequired("Charger Id"),
});

//***********************************************IMAGE API'S VALIDATION*******************************************************
// 1.create Image validation
export const createImageValidation = Yup.object().shape({
  token: tokenValidation,
  filename: validateStrRequired("File Name"),
  data: validateStrRequired("Image"),
});

//**********************************************STATUS API'S VALIDATION*******************************************************
//1. create Stauts validation
export const createStatusValidation = Yup.object().shape({
  token: tokenValidation,
  id: validateStrRequired("Id"),
  type: validateStrRequired("Type"),
  details: Yup.string(),
});

// 2.validation to get status by OwnerId
export const getStatusByOwnerIdValidation = Yup.object().shape({
  token: tokenValidation,
  ownerId: validateStrRequired("Owner Id"),
  limit: Yup.number(),
  page: Yup.number(),
  type: validateStrRequired("Type"),
});

//*********************************************TRANSACTION API'S VALIDATION*****************************************************
// 1.create transaction validation
export const createTransactionValidation = Yup.object().shape({
  token: tokenValidation,
  chargerId: validateStrRequired("Charger Id"),
  transactionId: validateStrRequired("transaction Id"),
  userId: validateStrRequired("user Id"),
  meterStart: validateStrRequired("meter Start"),
  meterStop: Yup.string(),
  startTime: validateStrRequired("Start Time"),
  stopTime: Yup.string(),
  reason: Yup.string(),
  type: Yup.string(),
  connectorId: Yup.number().positive().required("Connector Id is required."),
  mode: Yup.object().shape({
    type: Yup.string(),
    value: Yup.string(),
  }),
});

// 2.validation to get the transaction by ownerId
export const getTransactionByOwnerIdValidation = Yup.object().shape({
  token: tokenValidation,
  ownerId: validateStrRequired("Owner Id"),
  limit: Yup.number(),
  page: Yup.number(),
});

//*************************************************USER API'S VALIDATION*********************************************************
export const createUserValidation = Yup.object().shape({
  // token: tokenValidation,
  name: validateStrRequired("Name"),
  phoneNumber: validatePhoneNumber,
  email: Yup.string().email("Please enter valid email"),
  hostId: validateEmail,
  status: validateStrRequired("Status"),
  balance: Yup.number(),
  creditLimit: Yup.number(),
  rfid: Yup.array().of(
    Yup.object().shape({
      idTag: Yup.string().matches(/^[a-zA-Z0-9]{16}$/, "RFID must be a 16-character alphanumeric string"),
    })
  ),
});

export const hostIdValidation = Yup.object().shape({
  hostId: validateEmail,
});

export const phoneNumberValidation = Yup.object().shape({
  phoneNumber: validatePhoneNumber,
});

export const blockUserValidation =Yup.object().shape({
  hostId: validateEmail,
  phoneNumber: validatePhoneNumber,
  status:validateStrRequired("Status")
});

//*************************************************OWNER API's VALIDATION*********************************************************
// 1. validation to create the owner
export const createOwnerValidation = Yup.object().shape({
  token: tokenValidation,
  name: validateStrRequired("Name"),
  phoneNumber: validatePhoneNumber,
  email: validateEmail,
  type: validateStrRequired("type"),
  role: validateStrRequired("role"),
  ownerId: validateStrRequired("ownerId"),
});

// 2. validation to get the owner details
export const getOwnerValidation = Yup.object().shape({
  token: tokenValidation,
  email: validateEmail,
});

//*************************************************INVOICE VALIDATION***********************************************************
// Validate invoice details
export const downloadInvoiceValidation = Yup.object().shape({
  token: tokenValidation,
  chargerId: validateStrRequired("Charger Id"),
  transactionId: validateStrRequired("transaction Id"),
  startTime: validateStrRequired("Start Time"),
  endTime: validateStrRequired("Stop Time"),
  phno: validatePhoneNumber,
  email: Yup.string().email("User Email-Id is invalid").required("Please enter valid Email"),
  serviceProvider: validateStrRequired("serviceProvider"),
  GST: validateStrRequired("GST"),
  address: validateStrRequired("address"),
  consumption: Yup.number().required("consumption is required."),
  description: validateStrRequired("description"),
  price: Yup.number().required("price is required."),
});
